import jQuery from 'jquery';
import moment from 'moment';
import Swal from 'sweetalert2';
import validator from 'validator';
import authHelper, { getMpAuthData } from './helpers/authHelper';
require('datatables.net');
import { axiosErrorHandler, axiosResponseHandler, callTheBaseServerGet, callTheBaseServerPost, callTheBaseServerPost } from './helpers/axiosHelper';

import { apiBaseUrl } from './helpers/config';
import { addDNoneClass, byId, Toast } from './helpers/utility';


// initializing jquery 
const $ = window.$ = window.jQuery = jQuery;




authHelper.validate().then(async () => {




    $('#data_table').DataTable({
        processing: true,
        serverSide: true,


        ajax: {
            url: `${apiBaseUrl}/basic/getAllUsersDataTable`,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader('Authorization', `Bearer ${getMpAuthData().refreshToken}`);
            },
            error: function (jqXHR, exception) {
                console.log({ jqXHR });
                console.log({ exception });
                // Your error handling logic here..
            }
        },
        aaSorting: [],
        columns: [
            { data: 'userId' },
            { data: 'fullName' },
            { data: 'email' },
            { data: 'mobileNumber' },
            {
                orderable: false,
                data: 'users_extra_details',
                render: function (data) {
                    const { city } = data;
                    return `${city}`;
                }

            },
            {
                orderable: false,
                data: 'users_wallets',
                render: function (data) {
                    const { main } = data;
                    return `₹ ${main}`;
                }

            },
            {
                orderable: false,
                data: 'users_wallets',
                render: function (data) {
                    const { autoInvestmentLocked } = data;
                    return `₹ ${autoInvestmentLocked}`;
                }

            },

            {
                orderable: false,
                data: 'users_wallets',
                render: function (data) {
                    const { autoInvestmentProfit } = data;
                    return `₹ ${autoInvestmentProfit}`;
                }

            },
            {
                orderable: false,
                data: 'users_wallets',
                render: function (data) {
                    const { yamashaStocksQuantity } = data;
                    return `${yamashaStocksQuantity}`;
                }

            },
            {
                orderable: false,
                data: 'users_wallets',
                render: function (data) {
                    const { yamashaStocksInvestment } = data;
                    return `₹ ${yamashaStocksInvestment}`;
                }

            },
            {
                data: 'createdAt',
                render: function (data) {
                    const createdAt = data;
                    const date = moment(createdAt * 1000).format('DD/MM/YYYY');
                    const time = moment(createdAt * 1000).format('LT');
                    return `${date} <br> ${time}`;
                }

            },
            {
                data: {

                    fullName: 'fullName',
                    users_bank_details: 'users_bank_details'
                },
                orderable: false,
                // eslint-disable-next-line no-unused-vars
                render: function (data, type, row, meta) {

                    return `<button onclick="usersPageFun.showWithdrawMethods(${JSON.stringify(data).split('"').join('&quot;')})"
                    class="btn btn-success" > Show </button>`;
                }
            },
            {
                data: {
                    userId: 'userId',
                    fullName: 'fullName',
                    users_wallets: 'users_wallets',

                },
                orderable: false,
                // eslint-disable-next-line no-unused-vars
                render: function (data, type, row, meta) {

                    return `<button onclick="usersPageFun.updateMainWallet.init(${JSON.stringify(data).split('"').join('&quot;')})"
                    class="btn btn-success">Update Wallet</button>`;
                }
            },
            {
                data: {
                    userId: 'userId'
                },
                orderable: false,
                // eslint-disable-next-line no-unused-vars
                render: function (data, type, row, meta) {
                    const {userId} =data;

                    return `<button onclick="location.href ='./edit_user_data.html?userId=${userId}'"
                    class="btn btn-success">edit_user_data</button>`;
                }
            }

        ]
    });

    const updateUserWalletCardDivElement = byId('updateUserWalletCardDivElement');
    const userIdInput = byId('userIdInput');
    const fullNameInput = byId('fullNameInput');
    const depositCreditInput = byId('depositCreditInput');
    const walletSelectInput = byId('walletSelectInput');
    const actionSelectInput = byId('actionSelectInput');
    const amountInput = byId('amountInput');
    const commentInput = byId('commentInput');

    const usersPageFun = {
        showWithdrawMethods: (data) => {


            const { fullName,
                users_bank_details } = data;

            const { bankName, accountNumber, ifscCode, upiId } = users_bank_details;

            Swal.fire({
                title: `${fullName} withdraw methods`,
                icon: 'info',
                html:
                    `<div> BANK_NAME = ${bankName} <br>  BANK_AC_NUM = ${accountNumber} <br> BANK_IFSC = ${ifscCode} <br> UPI_ID = ${upiId} <br>     </div>`,
                allowOutsideClick: () => {
                    const popup = Swal.getPopup();
                    popup.classList.remove('swal2-show');
                    setTimeout(() => {
                        popup.classList.add('animate__animated', 'animate__headShake');
                    });
                    setTimeout(() => {
                        popup.classList.remove('animate__animated', 'animate__headShake');
                    }, 500);
                    return false;
                }

            });
        },
        updateMainWallet: {

            init: (data) => {
                const { userId, fullName, users_wallets } = data;
                const { main } = users_wallets;
                addDNoneClass(updateUserWalletCardDivElement, false);
                userIdInput.value = userId;
                fullNameInput.value = fullName;
                depositCreditInput.value = main;


            },
            cancel: () => {

                addDNoneClass(updateUserWalletCardDivElement, true);

            },
            submit: async () => {


                try {
                    // validation 
                    if (amountInput.value < 1) {

                        Toast.fire({
                            icon: 'error',
                            title: 'Amount Must be more than 1'
                        });

                        return false;
                    }
                    const userId = userIdInput.value;
                    const data = {
                        userId,

                        actionSelect: actionSelectInput.value,
                        amount: amountInput.value,
                        comment: commentInput.value
                    };
                    const response = await callTheBaseServerPost('/basic/updateUserWallet', { data: data });
                    axiosResponseHandler(response);
                    const res = response.data;
                    console.log(res);

                    if (res.status === 'success') {
                        Swal.fire({
                            title: 'User Wallet Updated',
                            icon: 'success',
                            showConfirmButton: false,


                            allowOutsideClick: false,


                        });

                        setTimeout(() => {
                            location.reload();
                        }, 3000);
                    }
                } catch (error) {
                    axiosErrorHandler(error);
                    console.log(error);
                }


            },

        }
    };


    window.usersPageFun = usersPageFun;



    const updateUserPasswordCardDivElement = byId('updateUserPasswordCardDivElement');
    const updateUserPasswordUserIdInput = byId('updateUserPasswordUserIdInput');
    const newPasswordInput = byId('newPasswordInput');
    const confirmNewPasswordInput = byId('confirmNewPasswordInput');
    const updateUserPasswordFun = {
        init: ({ userId }) => {
            addDNoneClass(updateUserPasswordCardDivElement, false);
            updateUserPasswordUserIdInput.value = userId;
            newPasswordInput.value = '';
            confirmNewPasswordInput.value = '';
        },
        cancel: () => {
            addDNoneClass(updateUserPasswordCardDivElement, true);
        },
        submit: async () => {
            try {
                // validation 
                if (!validator.isLength(newPasswordInput.value, { min: 8, max: 50 })) {

                    Toast.fire({
                        icon: 'error',
                        title: 'Password length Must Between 8 to 50'
                    });

                    return false;
                }
                if (newPasswordInput.value !== confirmNewPasswordInput.value) {

                    Toast.fire({
                        icon: 'error',
                        title: 'Password not matching'
                    });

                    return false;
                }

                const data = {
                    userId: updateUserPasswordUserIdInput.value,
                    password: newPasswordInput.value
                };
                const response = await callTheBaseServerPost('/users/updateUserPassword', { data: data });
                axiosResponseHandler(response);
                const res = response.data;
                console.log(res);

                if (res.status === 'success') {
                    Swal.fire({
                        title: 'User Password Updated',
                        icon: 'success',
                        showConfirmButton: true,


                        allowOutsideClick: true,
                        timer: 3000

                    });


                }



            } catch (error) {
                console.log(error);
                axiosErrorHandler(error);
            }
        }
    };

    const deleteUserFun = {
        init: ({ userId, fullName }) => {
            Swal.fire({
                title: 'Are you sure?',
                text: ` to Permanently  Delete Account of ${fullName}[${userId}]`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    deleteUserFun.submit({ userId });
                }
            });
        },

        submit: async ({ userId }) => {
            try {



                const response = await callTheBaseServerGet(`/users/deleteUser/${userId}`);
                axiosResponseHandler(response);
                const res = response.data;
                console.log(res);

                if (res.status === 'success') {
                    Swal.fire({
                        title: 'Deleted!',
                        icon: 'success',
                        text: `User has been deleted.`,
                        showConfirmButton: false,


                        allowOutsideClick: false,


                    });
                    setTimeout(() => {
                        location.reload();
                    }, 3000);


                }



            } catch (error) {
                console.log(error);
                axiosErrorHandler(error);
            }
        }
    };

    window.deleteUserFun = deleteUserFun;




    window.updateUserPasswordFun = updateUserPasswordFun;











});


